"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validCssUnitPattern = exports.validCssUnit = exports.iconPattern = void 0;
var iconPattern = /^icon-/;
exports.iconPattern = iconPattern;
var validCssUnitPattern = /0|px|%|^initial|^inherit$/;
exports.validCssUnitPattern = validCssUnitPattern;

var validCssUnit = function validCssUnit(item) {
  return validCssUnitPattern.test(item);
};

exports.validCssUnit = validCssUnit;